import CloseIcon from '@mui/icons-material/Close';
import Carousel from 'react-material-ui-carousel'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from '@mui/material';
import { useTreatmentOnGoing } from 'context';

type IDialogImage = {
  title: string;
  isOpen: boolean;
  onClose: () => void;
  variant?: 'image' | 'outlined' | 'contained';
  loading?: boolean;
};

export const DialogImage: React.FC<IDialogImage> = ({
  title,
  isOpen,
  onClose,
  loading,
}) => {
  const handleClose = () => {
    if (loading) {
      return;
    }
    onClose();
  };

  const { imgs } = useTreatmentOnGoing();
  return (
    <Dialog style={{height: '100vh'}} fullWidth={true} maxWidth='lg' open={isOpen} onClose={handleClose}>
      <DialogTitle>
        {title}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          disabled={loading}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[800],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent style={{maxWidth: '80vw', maxHeight: '100vh'}}>
        <Carousel>
          {
            imgs.map((image, i)=> { 
              return ( 
                <Grid style={{maxWidth: '80vw', maxHeight: '80vh'}} key={i} container display={'flex'} flexDirection={'row'} justifyContent={'center'} alignContent={'center'} spacing={2}>
                  <img style={{maxWidth: '80vw', maxHeight: '80vh'}} alt="" src={`data:image/png;charset=utf-8;base64,${image}`}/> 
                </Grid>
                )
                }
              )
            } 
        </Carousel>
      </DialogContent>
    </Dialog>
  );
};
